<h3-layer-view-settings [viewModeOptions]="viewModeOptions">
  <h3-raster-coding-layer-view-settings-popover></h3-raster-coding-layer-view-settings-popover>
</h3-layer-view-settings>
